import axios from 'axios';
import { getBrowserNameAndVersion, getOSInfo, getScreenResolution } from '@/Utils/helpers';

const BASE_URL = '/api/session-analytics';

class SessionAnalyticsService {
  /**
   * @param
   * @returns
   */
  static async fetchSinglePhase({ id, phaseTitle }) {
    try {
      const res = await axios.get(`${BASE_URL}/${id}/phase/${phaseTitle}`);
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} id
   * @returns
   */
  static async fetchAllPhases(id) {
    try {
      const res = await axios.get(`${BASE_URL}/${id}/phase`);
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  static async startPhase({ id, type }) {
    try {
      const res = await axios.post(
        `${BASE_URL}/phase/start`,
        {
          session_id: id,
          type,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  static async endPhase({ id, type }) {
    try {
      const res = await axios.post(
        `${BASE_URL}/phase/end`,
        {
          session_id: id,
          type,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  static logUserPresence(userData, action) {
    axios.post(
      route('session.log-user-presence-data'),
      {
        user: userData,
        action,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  /** Check if user is already present in the session */
  static async isUserAlreadyPresent(sessionId, userId) {
    try {
      const res = await axios.get(route('session.user-already-present', [sessionId, userId]));
      return !!res.data;
    } catch (error) {
      throw error.response;
    }
  }

  static async logUserSystemData(pageProps, cameraName) {
    const userSystemData = {
      sessionId: pageProps.session.id,
      userId: pageProps.user.id,
      browser: getBrowserNameAndVersion(),
      os: getOSInfo(),
      resolution: getScreenResolution(),
      camera: cameraName,
    };

    setTimeout(() => {
      axios.post(route('session.log-user-system-data'), userSystemData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }, 3000);
  }
}

export default SessionAnalyticsService;
